import React from "react";
import {AutoVisit} from "~/apps/packages/auto-visits/queries";
import {MultiSelectChipInput} from "~/apps/core/ui/ChipInput/MultiSelectChipInput";
import {FiberManualRecord} from "@mui/icons-material";
import {Grid} from "@mui/material";
import {getAutoVisitStatusColor} from "~/apps/packages/auto-visits/utils";

const STATUSES: AutoVisit["status"][] = [
    "Запланирован",
    "В порту",
    "На согласовании",
    "Ошибка",
    "Завершен",
    "Отменен"
];


export type AutoVisitStatusChipInputProps = {
    value?: AutoVisit["status"][]
    onChange?: (value: AutoVisit["status"][]) => any
    disabled?: boolean
}


export const AutoVisitStatusChipInput = (props: AutoVisitStatusChipInputProps) => {
    return (
        <MultiSelectChipInput {...props} title="Статус" options={
            STATUSES.map(status => ({
                value: status,
                title: (
                    <Grid container alignItems="center">
                        <FiberManualRecord style={{color: getAutoVisitStatusColor(status), width: 12, marginRight: 8}}/>
                        {status}
                    </Grid>
                ),
            }))
        }/>
    )
}